// extracted by mini-css-extract-plugin
export default {"container":"Location_container__F-tuH","location":"Location_location__W8J+k","map":"Location_map__BEhnc","addressInformation":"Location_addressInformation__jIatz"};